import axios from '@/api/axios';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
    results: [],
    resultsFilters: {
      groupOptions: [],
      disciplineOptions: [],
      genderOptions: [],
      ageGroupOptions: [],
    },
  },
})
  .get({
    action: 'getTournamentResults',
    property: 'results',
    path: ({ catalogId }) => `/shop/${catalogId}/results`,
  })
  .get({
    action: 'getTournamentResultsFilters',
    property: 'resultsFilters',
    path: ({ catalogId }) => `/shop/${catalogId}/results/filters`,
  })
  .get({
    action: 'exportTournamentResults',
    path: ({ catalogId }) => `/shop/${catalogId}/results/export`,
    requestConfig: {
      responseType: 'blob',
    },
  })
  .post({
    action: 'validateResultsImport',
    path: ({ catalogId }) => `/shop/${catalogId}/results/import/validate`,
  })
  .post({
    action: 'uploadResultsImport',
    path: ({ catalogId }) => `/shop/${catalogId}/results/import`,
  })
  .getStore();

store.getters = {
  results: (s) => s.results,
  resultsFilters: (s) => s.resultsFilters,
};

export default store;
